/**
 * 封面网格(W-7)。Web 原生 <input type=file multiple> 选真实文件(_shared C-4 正向差异)。
 * 1~9 张;首图主图标记;删除;超 9 静默 no-op;提交中禁选。上传延迟到守卫全过后(见 PublishPage)。
 * 视觉对齐 design/publish.html:`.grid-cards.cols-4` + `.upload-box`。
 */
export interface CoverItem {
  key: string;
  /** 预览地址:本地 objectURL 或既有远端 URL。 */
  previewUrl: string;
  /** 新选本地文件(待上传);既有远端封面无此字段。 */
  file?: File;
  /** 既有远端封面 finalUrl(编辑模式复用,不重传)。 */
  remoteUrl?: string;
}

const MAX_COVERS = 9;

export function CoverImageGrid({
  covers,
  disabled,
  onAdd,
  onRemove,
}: {
  covers: CoverItem[];
  disabled: boolean;
  onAdd: (files: File[]) => void;
  onRemove: (key: string) => void;
}) {
  const slotsLeft = MAX_COVERS - covers.length;

  return (
    <div>
      <div
        className="grid-cards cols-4"
        style={{ gridTemplateColumns: 'repeat(4, 1fr)', gap: 'var(--space-4)' }}
      >
        {covers.map((c, i) => (
          <div key={c.key} className="upload-box" style={{ position: 'relative', overflow: 'hidden' }}>
            <img
              src={c.previewUrl}
              alt={`封面 ${i + 1}`}
              style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }}
            />
            {i === 0 && (
              <div style={{ position: 'absolute', top: 6, left: 6 }}>
                <span className="badge badge-primary">主图</span>
              </div>
            )}
            {!disabled && (
              <button
                type="button"
                aria-label={`删除封面 ${i + 1}`}
                onClick={() => onRemove(c.key)}
                style={{
                  position: 'absolute',
                  top: 4,
                  right: 4,
                  width: 22,
                  height: 22,
                  borderRadius: 'var(--radius-full)',
                  border: 'none',
                  background: 'var(--color-scrim)',
                  color: '#fff',
                  cursor: 'pointer',
                  lineHeight: 1,
                }}
              >
                ✕
              </button>
            )}
          </div>
        ))}

        {slotsLeft > 0 && (
          <label
            className="upload-box"
            style={{
              borderStyle: 'solid',
              color: 'var(--color-primary)',
              cursor: disabled ? 'not-allowed' : 'pointer',
            }}
          >
            ＋ 添加
            <input
              type="file"
              accept="image/*"
              multiple
              hidden
              disabled={disabled}
              onChange={(e) => {
                const files = Array.from(e.target.files ?? []).slice(0, slotsLeft);
                if (files.length) onAdd(files);
                e.target.value = '';
              }}
            />
          </label>
        )}
      </div>
      <p className="hint">支持 1~9 张,首图为主图。提交时上传,建议清晰能体现商品的图片。</p>
    </div>
  );
}
